import { Component } from "@angular/core";

@Component({
  selector: 'colgroup[app-dt-colgroup]',
  standalone: true,
  template: `<ng-content></ng-content>`,
  styleUrls: ['dt-colgroup.component.scss'],
})
export class DtColgroupComponent {}
